import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';

const searchMessages = createTranslationMessages({
  ref: searchTranslationRef,
  full: true,
  messages: {
    'searchModal.viewFullResults': 'Ver resultados completos',
    'sidebarSearchModal.title': 'Buscar',
    'searchType.allResults': 'Todos os resultados',
    'searchType.tabs.allTitle': 'Todos',
    'searchType.accordion.allTitle': 'Todos',
    'searchType.accordion.collapse': 'Recolher',
    'searchType.accordion.numberOfResults': '{{number}} Resultados'
  },
});

const searchReactMessages = createTranslationMessages({
  ref: searchReactTranslationRef,
  full: true,
  messages: {
    'searchBar.title': 'Buscar',
    'searchBar.placeholder': 'Buscar em {{org}}',
    'searchBar.clearButtonTitle': 'Limpar',
    'searchFilter.allOptionTitle': 'Todos',
    'searchPagination.limitLabel': 'Resultados por página:',
    'searchPagination.limitText': 'de {{num}}',
    'noResultsDescription': 'Desculpe, nenhum resultado foi encontrado',
    'searchResultGroup.linkTitle': 'Ver Todos',
    'searchResultGroup.addFilterButtonTitle': 'Adicionar filtro',
    'searchResultPager.next': 'Próximo',
    'searchResultPager.previous': 'Anterior',
  },
});

export const searchTranslationModule = createFrontendModule({
  pluginId: 'search',
  extensions: [
    TranslationBlueprint.make({
      name: 'search-overrides',
      params: {
        resource: searchMessages
      }
    }),
    TranslationBlueprint.make({
      name: 'search-react-overrides',
      params: {
        resource: searchReactMessages
      }
    })
  ]
})